import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=ef2d301c&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=ef2d301c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2d301c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef2d301c')) {
      api.createRecord('ef2d301c', component.options)
    } else {
      api.reload('ef2d301c', component.options)
    }
    module.hot.accept("./goodsInfo.vue?vue&type=template&id=ef2d301c&scoped=true", function () {
      api.rerender('ef2d301c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goodsManage/edit/components/goodsInfo.vue"
export default component.exports